var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrandImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 649,
    height: 811,
    viewBox: "0 0 649 811",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    x: 247.5,
    width: 199.375,
    height: 199.314,
    rx: 99.6568,
    fill: "#60269E"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 611.687,
    width: 446.875,
    height: 199.314,
    rx: 99.6568,
    fill: "#E2E729"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.625,
    y: 406.875,
    width: 199.203,
    height: 199.142,
    rx: 99.5709,
    fill: "#E2E729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.227 0C602.084 0 645.325 41.1612 648.626 93.1696C648.85 96.6971 645.963 99.5709 642.428 99.5709H456.025C452.49 99.5709 449.604 96.6971 449.828 93.1696C453.128 41.1612 496.369 0 549.227 0Z",
    fill: "#FF5100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.5 385.929V208.463C247.5 204.928 250.365 202.063 253.9 202.063H431.421C437.123 202.063 439.978 208.958 435.945 212.989L258.425 390.455C254.393 394.486 247.5 391.63 247.5 385.929Z",
    fill: "#101820"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649 795.552V618.087C649 614.552 646.135 611.687 642.6 611.687H465.079C459.377 611.687 456.522 618.581 460.555 622.613L638.075 800.079C642.107 804.109 649 801.254 649 795.552Z",
    fill: "#F478C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.625 208.463C449.625 204.928 452.49 202.063 456.025 202.063H642.6C646.135 202.063 649 204.928 649 208.463V394.977C649 398.511 646.135 401.377 642.6 401.377H456.025C452.49 401.377 449.625 398.511 449.625 394.977V208.463Z",
    fill: "#F478C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.5 413.275C247.5 409.74 250.365 406.875 253.9 406.875H440.475C444.01 406.875 446.875 409.74 446.875 413.275V599.788C446.875 603.323 444.01 606.188 440.475 606.188H253.9C250.365 606.188 247.5 603.323 247.5 599.788V413.275Z",
    fill: "#60269E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandImg);
export default __webpack_public_path__ + "static/media/brand-img.98888f06950907921406a0467bd5380b.svg";
export { ForwardRef as ReactComponent };